export const startLocationText = 'O';

export const arrivalLocationText = 'S';

export const endLocationText = 'D';

export const createCustomMarker = (text: string = '') => {
  const size = 36;
  let color: string | undefined;

  if (
    text === startLocationText ||
    text.includes(arrivalLocationText) ||
    text === endLocationText
  ) {
    color = '#FFFFFF';
  } else {
    color = '#10B981';
  }

  // カスタムマーカーの要素を作成
  const el = document.createElement('div');
  el.className = 'custom-marker';

  // カスタムスタイルを適用
  el.style.width = `${size}px`;
  el.style.height = `${size}px`;
  el.style.backgroundColor = color;
  el.style.borderRadius = '50%';
  el.style.boxShadow = '0 0 5px rgba(0, 0, 0, 0.5)';

  // 文字のスタイルを中央に配置
  el.style.display = 'flex';
  el.style.justifyContent = 'center';
  el.style.alignItems = 'center';
  el.style.color = 'black';
  el.style.fontSize = `${size / 2}px`;

  // マーカー内に文字を追加
  el.textContent = text;

  // 枠線の色を設定（textの内容に応じて）
  if (text === 'O') {
    el.style.border = '2px solid red';
  } else if (text === 'D') {
    el.style.border = '2px solid blue';
  } else {
    el.style.border = '2px solid yellow';
  }

  return el;
};
